var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('v-card-text',[_c('jur-form',{attrs:{"init-jur-id":_vm.jurId,"init-is-show-jur-prefetch":_vm.isShowJurPrefetch},on:{"created":_vm.onCreatedJur}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }